const {
  paramStore,
} = require('../../../../../stores');
export const cryptoAccountId$ = paramStore('id');
